import {parseDateWithFormat} from '@shared/dateUtils';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';

export enum MileageRegisterCase {
  /**
   * 1-1
   * 4.1.8 vhcleLink 사진등록요청일자-1일자의 최종 누적주행거리
   * 01 전송필요 / 03 불필요
   */
  CASE1_1,
  /**
   * 1-2
   * 4.1.9 seasonLink 3/31의 최종 누적주행거리 전송
   * 02 불필요 / 02 종료 등록 필요
   */
  CASE1_2,
  /**
   * 2
   * 4.1.9 seasonLink 11/30의 최종 누적주행거리 전송
   * 02 불필요 / 01 시작 등록 필요
   */
  CASE2,
  /**
   * 3
   * 4.1.8 vhcleLink 사진등록요청일자-1일자의 최종 누적주행거리
   * 4.1.9 seasonLink 11/30의 최종 누적주행거리 전송
   * 01 전송필요 / 01 시작 등록 필요
   */
  CASE3,
  /**
   * 4
   * 4.1.8 vhcleLink 사진등록요청일자-1일자의 최종 누적주행거리
   * 4.1.9 seasonLink 3/31의 최종 누적주행거리 전송
   * 01 전송필요 / 02 종료 등록 필요
   */
  CASE4,
}

function getMileageRegisterCase({drvngRgsYn, seasonRgsYn}: {drvngRgsYn: string; seasonRgsYn: string}) {
  if (drvngRgsYn === '01' && seasonRgsYn === '03') {
    return MileageRegisterCase.CASE1_1;
  }
  if (drvngRgsYn === '02' && seasonRgsYn === '02') {
    return MileageRegisterCase.CASE1_2;
  }
  if (drvngRgsYn === '02' && seasonRgsYn === '01') {
    return MileageRegisterCase.CASE2;
  }
  if (drvngRgsYn === '01' && seasonRgsYn === '02') {
    return MileageRegisterCase.CASE3;
  }
  if (drvngRgsYn === '01' && seasonRgsYn === '01') {
    return MileageRegisterCase.CASE4;
  }
  throw new Error('getMileageRegisterCase error');
}

function useMileageRegister(vin: string) {
  const {
    data: {
      drvng_rgs_yn: drvngRgsYn,
      season_rgs_yn: seasonRgsYn,
      drvng_dstnc_rgsde: drvngDstncRgsde,
      drvng_dstnc_endde: drvngDstncEndde,
      season_drvng_dstnc: seasonDrvngDstnc,
    },
  } = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.ecoMileageController.getInfoLink)],
    queryFn: () =>
      diApi.ecoMileageController.getInfoLink({
        vin,
      }),
    select: (data) => data.data.rtn_data,
  });

  const mileageRegisterCase = getMileageRegisterCase({drvngRgsYn, seasonRgsYn});

  return {
    mileageRegisterCase,
    drvngDstncRgsde: parseDateWithFormat(drvngDstncRgsde),
    drvngDstncEndde: parseDateWithFormat(drvngDstncEndde),
    seasonDrvngDstnc,
  };
}

export default useMileageRegister;
